import React, { useEffect, useState } from 'react';
import { RiArrowDownSLine } from "react-icons/ri";

import heroDesktop from '../assets/slider/hero-image-home.webp';
// import heroMobile from '../assets/slider/hero-image-home-md.webp';
import heroJpg from '../assets/slider/hero-image-home.jpg';
import heroMobileJpg from '../assets/slider/hero-image-home-md.jpg';

/* ✅ DEFINE HERE (outside component) */
const WORDS = [
  "tallest building.",
  "largest flower garden.",
  "fastest roller coaster.",
  "only seven-star hotel."
];


export default function Slider() {


  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
      const current = WORDS[index % WORDS.length];
      let timeout;

      if (isDeleting) {
        timeout = setTimeout(() => {
          setText(current.substring(0, text.length - 1));
        }, 80);   // 🔽 slower delete (was 50)
      } else {
        timeout = setTimeout(() => {
          setText(current.substring(0, text.length + 1));
        }, 180);  // 🔽 slower typing (was 100)
      }

      if (!isDeleting && text === current) {
        timeout = setTimeout(() => setIsDeleting(true), 2500); // 🔽 longer pause
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setIndex(prev => prev + 1);
      }

      return () => clearTimeout(timeout);
    }, [text, isDeleting, index]);


  return (
    <div className="heroSlider">

      <picture>
        <source media="(max-width:768px)" srcSet={heroDesktop} type="image/webp" />
        <source media="(max-width:768px)" srcSet={heroMobileJpg} />

        <source srcSet={heroDesktop} type="image/webp" />
        <source srcSet={heroJpg} />

        <img 
          src={heroJpg}
          className="heroImg"
          alt="Dubai skyline with Burj Khalifa"
         fetchpriority="high"
        />
      </picture>

      <div className="content">
        <div className="inner">

          <h1 className="text-white mb-5">
            Discover the world's{" "}
            <span className="highlight">{text}</span>
          </h1>

          <a className="updown" href="#explore-top-destination">
            <RiArrowDownSLine />
          </a>

        </div>
      </div>

    </div>
  );
}